export default "__VITE_ASSET__c8dd1890__"